
import { tokenState, userState } from './../services/auth';
import { apiUrl, axiosPost, errorHandling, post } from './../services/utils';
import { defineComponent } from 'vue'
import Toast from 'primevue/toast';
import BasicSpinner from '@/components/BasicSpinner.vue';
import { AlertState } from '@/services/AlertService';

export default defineComponent({
    data() {
        return {
            email: null,
            password: '',
            hasClicked: false,
            errors: [] as string[],
            emailError: [] as string[]
        };
    },
    methods: {
        login() {
            this.errors = [];
            this.emailError = [];
            if (this.validateEmail() && this.validatePassword()) {
                let formData = {
                    email: this.email,
                    password: this.password
                };
                this.hasClicked = true;
                let loginUrl = apiUrl + "auth/login";
                axiosPost(loginUrl, formData).then((result) => {
                    console.log(result);
                    tokenState.setToken(result.token);
                    userState.setUser(result.user);
                    userState.setAuth(true);
                    this.$router.push("/buildings");
                    this.hasClicked = false;
                }).catch((err) => {
                    this.handleLoginErrors(err)
                    this.hasClicked = false;
                });
            }
        },
        validatePassword(): boolean {
            if (!this.password) {
                this.errors.push('Yoou must enter a password')
                return false;
            }
            if (this.password.length < 4) {
                this.errors.push('Yoou must enter a password')
                return false;
            }
            return true;
        },
        validateEmail(): boolean {
            return true;
        },
        async handleLoginErrors(err: any) {
            let res = err.response;
            // extract the error message from the response
            const { message } = await res.data;
            // check if error messages have word email in it
            if (message.indexOf('email') >= 0) {
                this.emailError.push(message);
            } else {
                this.errors.push(message);
            }
            if (res.status == 401) {
                AlertState.displayError(message)
                this.$router.push('/login');
                throw new Error(message);
            } else if (res.status == 400) {
                AlertState.displayError(message)
                throw new Error(message);
            } else if (res.status == 422) {
                // get errors coming from laravel validation
                const { errors } = await res.data;
                let errorMessage = message;
                console.log(res.data)
                for (const key in errors) {
                    errorMessage = errorMessage + ' ' + `${errors[key]}`
                }
                // check if error messages have word email in it
                if (errorMessage.indexOf('email') >= 0) {
                    this.emailError.push(errorMessage);
                } else {
                    this.errors.push(errorMessage);
                }
                AlertState.displayError(errorMessage)
                throw new Error(message);
            } else {
                // AlertState.displayError(message)
                throw new Error(message);
            }
        }
    },
    components: { BasicSpinner }
})
